import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";

import "../../styles/globals.css";

/** Render a page into #root. Each HTML entry point calls this once. */
export function mount(page: ReactNode) {
  const root = document.getElementById("root");
  if (!root) throw new Error("#root missing");
  createRoot(root).render(<StrictMode>{page}</StrictMode>);
}
